import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=827f2e76&scoped=true&"
import script from "./Site.vue?vue&type=script&lang=js&"
export * from "./Site.vue?vue&type=script&lang=js&"
import style0 from "./Site.vue?vue&type=style&index=0&id=827f2e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827f2e76",
  null
  
)

export default component.exports